import { useMemo } from 'react';
import textAdditionalClassName from '../../../helpers/utils/TextAdditionalClassName';

interface BodyMediumSemiboldProps {
  children: React.ReactNode;
  className?: string;
  maxLines?: number;
  isClamp?: boolean;
  style?: React.CSSProperties;
  textBreak?: 'words' | 'characters';
  overflow?: 'hidden' | 'visible';
}

const BodyMediumSemibold = ({
  children,
  maxLines = 2,
  isClamp = false,
  className = '',
  style = {},
  textBreak = 'words',
  overflow = 'hidden',
  ...props
}: BodyMediumSemiboldProps & React.ComponentProps<'p'>) => {
  const lineClampStyle: React.CSSProperties = isClamp
    ? {
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
        display: '-webkit-box',
      }
    : {};

  const additionalClassName = useMemo(
    () => textAdditionalClassName(textBreak, overflow),
    [textBreak, overflow]
  );

  return (
    <p
      style={{ ...lineClampStyle, ...style }}
      className={`text-[14px] leading-[20px] font-semibold text-black90  ${additionalClassName} ${className}`}
      {...props}
    >
      {children}
    </p>
  );
};

export default BodyMediumSemibold;
